(function () {
  'use strict';
  window.TheoProductStores = window.TheoProductStores || {};
  window.TheoProductStickyManagers = window.TheoProductStickyManagers || {};

  function parseConfig(raw) {
    const match = String(raw || '').trim().match(/^#pp_(\d+!?(?:_\d+!?)*)__([a-zA-Z0-9-]+)$/);
    if (!match) return null;
    return { uuid: match[2], rules: match[1].split('_').map(function (part) {
      return { number: Number(part.replace('!', '')), only: part.endsWith('!') };
    }) };
  }
  function matchesNumber(title, number) {
    return new RegExp('(^|\\D)' + number + '(?=\\D|$)').test(String(title));
  }
  function createStickyManager(id) {
    const manager = { roots: new Set(), visibility: new Map(), observer: null };
    manager.ordered = function () {
      return Array.from(manager.roots).filter(function (r) { return r.isConnected; }).sort(function (a, b) {
        const p = a.compareDocumentPosition(b);
        return p & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : p & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
      });
    };
    manager.update = function () {
      const roots = manager.ordered();
      const primary = roots.find(function (r) { return r.querySelector('[data-tpw-sticky]'); });
      const visible = roots.some(function (r) { return manager.visibility.get(r) === true; });
      roots.forEach(function (r) {
        const sticky = r.querySelector('[data-tpw-sticky]');
        if (!sticky) return;
        sticky.classList.toggle('is-secondary-sticky', r !== primary);
        sticky.classList.toggle('is-visible', r === primary && !visible);
      });
    };
    if ('IntersectionObserver' in window) {
      manager.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { manager.visibility.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0); });
        manager.update();
      }, { threshold: [0, 0.001, 0.01, 0.1] });
    }
    manager.add = function (r) { manager.roots.add(r); manager.visibility.set(r, false); if (manager.observer) manager.observer.observe(r); manager.update(); };
    manager.remove = function (r) { if (manager.observer) manager.observer.unobserve(r); manager.roots.delete(r); manager.visibility.delete(r); manager.update(); };
    return manager;
  }
  function init(root) {
    if (!root || root.dataset.tpwInitialized === 'true') return;
    const json = root.querySelector('[data-tpw-product-json]');
    if (!json) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch (e) { console.error('THEO Widget: Invalid product JSON', e); return; }
    root.dataset.tpwInitialized = 'true';
    const id = String(data.productId);
    const config = parseConfig(data.aboConfig);
    const hasConfig = Boolean(String(data.aboConfig || '').trim());
    if (hasConfig && !config) console.error('THEO Widget: Ungültige abo_config:', data.aboConfig);
    const manager = window.TheoProductStickyManagers[id] || (window.TheoProductStickyManagers[id] = createStickyManager(id));
    manager.add(root);
    const store = window.TheoProductStores[id] || (window.TheoProductStores[id] = {
      variantId: String(root.dataset.initialVariantId || ''), purchaseType: 'single', sellingPlanId: null, quantity: 1
    });
    const $ = function (selector) { return root.querySelector(selector); };
    const $$ = function (selector) { return Array.from(root.querySelectorAll(selector)); };
    const els = {
      form: $('.theo-product-widget__form'), variantId: $('[data-tpw-variant-id]'), sellingPlan: $('[data-tpw-selling-plan]'),
      price: $('[data-tpw-price]'), compare: $('[data-tpw-compare-price]'), singlePrice: $('[data-tpw-single-price]'),
      subPrice: $('[data-tpw-subscription-price]'), subSettings: $('[data-tpw-subscription-settings]'),
      planSelect: $('[data-tpw-selling-plan-select]'), badge: $('[data-tpw-saving-badge]'), message: $('[data-tpw-saving-message]'),
      group: $('[data-tpw-purchase-group]'), singleOption: $('[data-tpw-single-option]'), subOption: $('[data-tpw-subscription-option]'),
      add: $('[data-tpw-add-button]'), addText: $('[data-tpw-add-button-text]'), quantity: $('[data-tpw-quantity]'),
      stickyImage: $('[data-tpw-sticky-image]'), stickyMeta: $('[data-tpw-sticky-meta]'), stickyPrice: $('[data-tpw-sticky-price]'),
      stickyAdd: $('[data-tpw-sticky-add]'), variantSelect: $('[data-tpw-variant-select]'),
      slides: $$('[data-tpw-slide]'), counter: $('[data-tpw-carousel-count]'), prev: $('[data-tpw-prev]'), next: $('[data-tpw-next]'),
      preview: $('[data-tpw-description-preview]'), full: $('[data-tpw-description-full]'), toggle: $('[data-tpw-description-toggle]'),
      dynamicCheckout: $('[data-tpw-dynamic-checkout-wrapper]'),
      galleryWrap: $('[data-tpw-gallery]'), galleryMain: $('[data-tpw-gallery-main]'),
      galleryThumbs: $('[data-tpw-gallery-thumbs]'), mobileStrip: $('[data-tpw-mobile-strip]'),
      lightbox: $('[data-tpw-lightbox]'), lightboxImage: $('[data-tpw-lightbox-image]'),
      lightboxStrip: $('[data-tpw-lightbox-strip]'), lightboxPrev: $('[data-tpw-lightbox-prev]'), lightboxNext: $('[data-tpw-lightbox-next]')
    };
    const variant = function () { return (data.variants || []).find(function (v) { return String(v.id) === String(store.variantId); }) || null; };
    function allowedPlans(v) {
      const plans = v.sellingPlans || [];
      if (!config) return hasConfig ? [] : plans;
      const rules = config.rules.filter(function (r) { return matchesNumber(v.title, r.number); });
      if (!rules.length) return [];
      return plans; // Selling-plan allocations are the Shopify source of truth for available plans.
    }
    function policy(v) {
      if (!v) return { single: false, sub: false, plans: [] };
      const plans = allowedPlans(v);
      if (!config) return hasConfig ? { single: false, sub: false, plans: [] } : { single: !v.requiresSellingPlan, sub: plans.length > 0, plans: plans };
      const matching = config.rules.filter(function (r) { return matchesNumber(v.title, r.number); });
      if (!matching.length) return { single: !v.requiresSellingPlan, sub: false, plans: [] };
      const only = matching.some(function (r) { return r.only; });
      return { single: !only && !v.requiresSellingPlan, sub: plans.length > 0, plans: plans };
    }
    function selectedPlan(v, p) { return p.plans.find(function (plan) { return String(plan.id) === String(store.sellingPlanId); }) || null; }
    function normalize(v) {
      const p = policy(v);
      if (!p.plans.some(function (plan) { return String(plan.id) === String(store.sellingPlanId); })) {
        store.sellingPlanId = p.plans.length ? String(p.plans[0].id) : null;
      }
      if (!p.single && p.sub) store.purchaseType = 'subscription';
      else if (p.single && !p.sub) store.purchaseType = 'single';
      else if (p.single && p.sub && store.purchaseType !== 'subscription') store.purchaseType = 'single';
      else if (!p.single && !p.sub) store.purchaseType = 'unavailable';
      return p;
    }
    function broadcast() {
      document.dispatchEvent(new CustomEvent('theo:product-state-change', { detail: {
        productId: id, sourceSectionId: root.dataset.sectionId || '', variantId: store.variantId,
        purchaseType: store.purchaseType, sellingPlanId: store.sellingPlanId, quantity: store.quantity
      } }));
    }
    let visibleSlides = [], slideIndex = 0, lightboxIndex = 0;

    function makeThumbImg(slide) {
      const img = document.createElement('img');
      img.src = slide.dataset.thumbSrc || (slide.querySelector('img') || {}).src || '';
      img.alt = (slide.querySelector('img') || {}).alt || '';
      img.loading = 'lazy';
      return img;
    }

    function buildGallery() {
      const rows = parseInt((els.galleryWrap && els.galleryWrap.dataset.galleryThumbRows) || '2', 10);
      const maxThumbs = 2 * rows;

      // Desktop thumbnail grid
      if (els.galleryThumbs) {
        els.galleryThumbs.replaceChildren();
        const thumbCount = Math.min(visibleSlides.length - 1, maxThumbs);
        for (let i = 0; i < thumbCount; i++) {
          const idx = i + 1;
          const isLast = i === maxThumbs - 1 && visibleSlides.length > 1 + maxThumbs;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tpw-thumb' + (idx === slideIndex ? ' is-active' : '');
          btn.dataset.slideIdx = String(idx);
          btn.appendChild(makeThumbImg(visibleSlides[idx]));
          if (isLast) {
            const ov = document.createElement('span');
            ov.className = 'tpw-thumb__overflow';
            ov.textContent = '+' + (visibleSlides.length - (1 + maxThumbs));
            btn.appendChild(ov);
          }
          btn.addEventListener('click', (function(i) { return function() { openLightbox(i); }; })(idx));
          els.galleryThumbs.appendChild(btn);
        }
      }

      // Mobile strip
      if (els.mobileStrip) {
        els.mobileStrip.replaceChildren();
        visibleSlides.forEach(function(slide, i) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tpw-thumb' + (i === slideIndex ? ' is-active' : '');
          btn.appendChild(makeThumbImg(slide));
          btn.addEventListener('click', (function(i) { return function() { activateSlide(i); }; })(i));
          els.mobileStrip.appendChild(btn);
        });
      }

      // Lightbox strip
      if (els.lightboxStrip) {
        els.lightboxStrip.replaceChildren();
        visibleSlides.forEach(function(slide, i) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tpw-thumb' + (i === lightboxIndex ? ' is-active' : '');
          btn.appendChild(makeThumbImg(slide));
          btn.addEventListener('click', (function(i) { return function() { lightboxGoto(i); }; })(i));
          els.lightboxStrip.appendChild(btn);
        });
      }
    }

    function updateThumbsActive() {
      if (els.galleryThumbs) {
        els.galleryThumbs.querySelectorAll('.tpw-thumb').forEach(function(t) {
          t.classList.toggle('is-active', t.dataset.slideIdx === String(slideIndex));
        });
      }
      if (els.mobileStrip) {
        Array.from(els.mobileStrip.querySelectorAll('.tpw-thumb')).forEach(function(t, i) {
          t.classList.toggle('is-active', i === slideIndex);
        });
      }
    }

    function activateSlide(index) {
      if (!visibleSlides.length) return;
      slideIndex = (index + visibleSlides.length) % visibleSlides.length;
      els.slides.forEach(function(slide) { slide.classList.remove('is-active'); });
      visibleSlides[slideIndex].classList.add('is-active');
      if (els.counter) els.counter.textContent = (slideIndex + 1) + ' / ' + visibleSlides.length;
      updateThumbsActive();
    }

    function openLightbox(index) {
      lightboxIndex = (index + visibleSlides.length) % visibleSlides.length;
      buildGallery(); // rebuild strip with correct active state
      updateLightboxImage();
      if (els.lightbox) { els.lightbox.hidden = false; document.body.style.overflow = 'hidden'; }
    }

    function closeLightbox() {
      if (els.lightbox) { els.lightbox.hidden = true; document.body.style.overflow = ''; }
    }

    function lightboxGoto(index) {
      lightboxIndex = (index + visibleSlides.length) % visibleSlides.length;
      updateLightboxImage();
      if (els.lightboxStrip) {
        Array.from(els.lightboxStrip.querySelectorAll('.tpw-thumb')).forEach(function(t, i) {
          t.classList.toggle('is-active', i === lightboxIndex);
        });
      }
    }

    function updateLightboxImage() {
      const slide = visibleSlides[lightboxIndex];
      if (!slide || !els.lightboxImage) return;
      const img = slide.querySelector('img');
      if (img) { els.lightboxImage.src = img.currentSrc || img.src; els.lightboxImage.alt = img.alt || ''; }
    }

    function filterGallery(v) {
      if (!els.slides.length) return;
      visibleSlides = els.slides.filter(function(slide) {
        const ids = (slide.dataset.variantIds || '').split(',').map(function(x) { return x.trim(); });
        const show = slide.dataset.unassigned === 'true' || ids.includes(String(v.id));
        slide.classList.toggle('is-filtered-out', !show);
        slide.classList.remove('is-active');
        return show;
      });
      let index = visibleSlides.findIndex(function(slide) { return String(slide.dataset.imageId) === String(v.featuredImageId); });
      activateSlide(index < 0 ? 0 : index);
      buildGallery();
      if (els.counter && els.counter.parentElement) els.counter.parentElement.hidden = visibleSlides.length < 2;
      if (els.prev) els.prev.hidden = visibleSlides.length < 2;
      if (els.next) els.next.hidden = visibleSlides.length < 2;
    }
    function render() {
      const v = variant(); if (!v) return;
      const p = normalize(v);
      const plan = store.purchaseType === 'subscription' ? selectedPlan(v, p) : null;
      const valid = v.available && (store.purchaseType === 'single' && p.single || store.purchaseType === 'subscription' && p.sub && Boolean(plan));
      if (els.variantId) els.variantId.value = String(v.id);
      $$('[data-tpw-variant-option]').forEach(function (input) { input.checked = String(input.value) === String(v.id); });
      if (els.variantSelect) els.variantSelect.value = String(v.id);
      if (els.singleOption) els.singleOption.hidden = !p.single;
      if (els.subOption) els.subOption.hidden = !p.sub;
      if (els.group) els.group.hidden = !(p.single && p.sub);
      // A single eligible purchase type still displays its label and price.
      if (els.planSelect) {
        els.planSelect.replaceChildren();
        p.plans.forEach(function (item) {
          const option = document.createElement('option'); option.value = String(item.id);
          option.textContent = item.name + ' – ' + item.priceFormatted;
          els.planSelect.appendChild(option);
        });
        if (store.sellingPlanId) els.planSelect.value = String(store.sellingPlanId);
      }
      $$('[data-tpw-purchase-type]').forEach(function (input) { input.checked = input.value === store.purchaseType; });
      if (els.subSettings) els.subSettings.hidden = store.purchaseType !== 'subscription' || !p.sub;
      if (els.sellingPlan) {
        els.sellingPlan.disabled = !(store.purchaseType === 'subscription' && plan);
        els.sellingPlan.value = plan ? String(plan.id) : '';
      }
      const displayedPrice = plan ? plan.priceFormatted : v.priceFormatted;
      if (els.price) els.price.textContent = displayedPrice;
      if (els.singlePrice) els.singlePrice.textContent = v.priceFormatted;
      if (els.subPrice) els.subPrice.textContent = p.plans.length ? (selectedPlan(v, p) || p.plans[0]).priceFormatted : '';
      if (els.compare) {
        els.compare.hidden = !(v.compareAtPrice && v.compareAtPrice > (plan ? plan.price : v.price));
        els.compare.textContent = els.compare.hidden ? '' : (v.compareAtPriceFormatted || '');
      }
      const savingPlan = selectedPlan(v, p) || p.plans[0];
      if (els.badge) {
        els.badge.hidden = !(savingPlan && savingPlan.saving > 0);
        els.badge.textContent = savingPlan && savingPlan.saving > 0 ? (savingPlan.savingPercent > 0 ? savingPlan.savingPercent + '% sparen' : savingPlan.savingFormatted + ' sparen') : '';
      }
      if (els.message) {
        els.message.hidden = !(savingPlan && savingPlan.saving > 0);
        els.message.textContent = savingPlan && savingPlan.saving > 0 ? 'Sie sparen ' + savingPlan.savingFormatted + ' pro Lieferung.' : '';
      }
      if (els.add) els.add.disabled = !valid;
      if (els.addText) els.addText.textContent = !v.available ? 'Ausverkauft' : !valid ? 'Kaufoption nicht verfügbar' : root.dataset.addToCartLabel || 'In den Warenkorb';
      if (els.quantity) els.quantity.value = String(store.quantity);
      if (els.stickyPrice) els.stickyPrice.textContent = displayedPrice;
      if (els.stickyMeta) els.stickyMeta.textContent = v.title + ' · ' + (store.purchaseType === 'subscription' ? 'Abo' : store.purchaseType === 'single' ? 'Einmaliger Kauf' : 'Nicht verfügbar');
      if (els.stickyAdd) els.stickyAdd.disabled = !valid;
      if (els.stickyImage && v.featuredImage) {
        els.stickyImage.removeAttribute('srcset'); els.stickyImage.removeAttribute('sizes'); els.stickyImage.src = v.featuredImage;
      }
      // Accelerated checkout can bypass our custom selector state; disable for subscription-only variants.
      if (els.dynamicCheckout) els.dynamicCheckout.hidden = !p.single || store.purchaseType === 'subscription';
      root.classList.toggle('tpw-is-subscription', store.purchaseType === 'subscription');
      filterGallery(v);
    }
    function changeVariant(value) {
      if (!data.variants.some(function (v) { return String(v.id) === String(value); })) return;
      store.variantId = String(value); render(); broadcast();
    }
    $$('[data-tpw-variant-option]').forEach(function (input) { input.addEventListener('change', function () { if (input.checked) changeVariant(input.value); }); });
    if (els.variantSelect) els.variantSelect.addEventListener('change', function () { changeVariant(els.variantSelect.value); });
    $$('[data-tpw-purchase-type]').forEach(function (input) { input.addEventListener('change', function () {
      if (!input.checked) return;
      const p = policy(variant());
      if (input.value === 'single' && !p.single || input.value === 'subscription' && !p.sub) { render(); return; }
      store.purchaseType = input.value; render(); broadcast();
    }); });
    if (els.planSelect) els.planSelect.addEventListener('change', function () {
      const p = policy(variant());
      if (!p.plans.some(function (x) { return String(x.id) === els.planSelect.value; })) return;
      store.sellingPlanId = els.planSelect.value; store.purchaseType = 'subscription'; render(); broadcast();
    });
    const minus = $('[data-tpw-quantity-minus]'), plus = $('[data-tpw-quantity-plus]');
    if (minus) minus.addEventListener('click', function () { store.quantity = Math.max(1, store.quantity - 1); render(); broadcast(); });
    if (plus) plus.addEventListener('click', function () { store.quantity = Math.max(1, store.quantity + 1); render(); broadcast(); });
    if (els.quantity) els.quantity.addEventListener('change', function () { store.quantity = Math.max(1, parseInt(els.quantity.value, 10) || 1); render(); broadcast(); });
    if (els.prev) els.prev.addEventListener('click', function () { activateSlide(slideIndex - 1); });
    if (els.next) els.next.addEventListener('click', function () { activateSlide(slideIndex + 1); });
    if (els.galleryMain) els.galleryMain.addEventListener('click', function() { if (window.innerWidth > 820) openLightbox(slideIndex); });
    if (els.galleryMain) {
      var touchStartX = 0;
      var touchStartY = 0;
      els.galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      els.galleryMain.addEventListener('touchend', function(e) {
        if (window.innerWidth > 820) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          activateSlide(dx < 0 ? slideIndex + 1 : slideIndex - 1);
        }
      }, { passive: true });
    }
    if (els.lightboxPrev) els.lightboxPrev.addEventListener('click', function() { lightboxGoto(lightboxIndex - 1); });
    if (els.lightboxNext) els.lightboxNext.addEventListener('click', function() { lightboxGoto(lightboxIndex + 1); });
    $$('[data-tpw-lightbox-close]').forEach(function(el) { el.addEventListener('click', closeLightbox); });
    if (els.lightbox) els.lightbox.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxGoto(lightboxIndex - 1);
      if (e.key === 'ArrowRight') lightboxGoto(lightboxIndex + 1);
    });
    if (els.preview && els.toggle) {
      requestAnimationFrame(function () { els.toggle.hidden = !(els.preview.scrollHeight > els.preview.clientHeight + 2); });
      els.toggle.addEventListener('click', function () {
        const expanded = els.toggle.dataset.expanded === 'true';
        els.preview.hidden = !expanded;
        if (els.full) els.full.hidden = expanded;
        els.toggle.textContent = expanded ? 'Weiterlesen' : 'Weniger anzeigen';
        els.toggle.dataset.expanded = expanded ? 'false' : 'true';
      });
    }
    if (els.stickyAdd && els.add) els.stickyAdd.addEventListener('click', function () { els.add.click(); });
    if (els.form) els.form.addEventListener('submit', function (event) {
      const v = variant(), p = policy(v), plan = selectedPlan(v, p);
      if (!v || !v.available || (store.purchaseType === 'subscription' ? !p.sub || !plan : !p.single)) {
        event.preventDefault(); console.error('THEO Widget: Ungültige Kaufoption'); return;
      }
      if (els.sellingPlan) {
        els.sellingPlan.disabled = store.purchaseType !== 'subscription';
        els.sellingPlan.value = store.purchaseType === 'subscription' ? String(plan.id) : '';
      }
    });
    document.addEventListener('theo:product-state-change', function (event) {
      const d = event.detail;
      if (!d || String(d.productId) !== id || d.sourceSectionId === root.dataset.sectionId) return;
      store.variantId = String(d.variantId); store.purchaseType = d.purchaseType || 'single';
      store.sellingPlanId = d.sellingPlanId ? String(d.sellingPlanId) : null;
      store.quantity = Math.max(1, Number(d.quantity) || 1);
      render();
    });
    render();
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-theo-product-widget]')) init(scope);
    scope.querySelectorAll('[data-theo-product-widget]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    // Remove detached widgets from the sticky manager.
    const roots = e.target.matches && e.target.matches('[data-theo-product-widget]') ? [e.target] : Array.from(e.target.querySelectorAll('[data-theo-product-widget]'));
    roots.forEach(function (root) { const manager = window.TheoProductStickyManagers[String(root.dataset.productId)]; if (manager) manager.remove(root); root.dataset.tpwInitialized = 'false'; });
  });
})();
